import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams } from "react-router-dom";
import { decodeToken, getToken } from "../../utils/TokenUtils";
import { API_URL, ENDPOINTS } from "../../constants/api";
import axios from 'axios'
const PassCard = () => {
  const { id, route,exam_id } = useParams();
  const token = getToken();
  const banner = decodeToken(token, "banner");
  const logo = decodeToken(token, "logo");
  const user_id = decodeToken(token, "id");
  const [data,setData]=useState([]);
  useEffect(() => {
        const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/${route}`;
        const fetchData = async () => {
          try {
            const response = await axios.post(url, {student_id:id,exam_id,user_id},{
              headers: {
                Authorization: token ? `Bearer ${token}` : '',
              },
            });
            
            setData(response.data.data);
    
          } catch (error) {
            console.error('Error fetching data:', error);
           
          }
        };
    
        fetchData();
      }, [route]);

  useEffect(() => {
    if (data.length<=0) {
      return
    }
    console.log("data: ",data)
    setTimeout(() => {
      window.print();
    }, 500);
  }, [route,id,data]);

  if (data.length<=0) {
      return
    }
  return (
    <div
      style={{
        border: "1px solid #000000",
        borderRadius: "35px",
        width: "98%",
        height: "21%",
        float: "left",
        margin: "10px",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#fff",
        position: "relative",
        padding: "10px",
      }}
    >
      <center>
        <img
          src={`${API_URL}/${banner}`}
          alt="Banner"
          width="90%"
          height="70px"
          style={{ borderRadius: "30px !important" }}
        />
      </center>

     
<h4
  style={{
    marginTop: "10px",
    textTransform: "uppercase",
    fontWeight: 700,
    display: "flex",
    justifyContent: "space-evenly", // or "space-evenly"
    alignItems: "center",
    padding: "0 10px",
    color: "#05259c",
    fontFamily: "Arial, sans-serif",
    gap: "20px" // controls spacing between the items
  }}
>
  <span>Academic Year {`${data[0]._academic_year}`}</span>
  <span style={{ textAlign: "center", fontWeight: 700 }}>
    {`${data[0]._title}`}
  </span>
  <span>{`${data[0]._exam_type}`}</span>
</h4>
 <hr />

      <br />

      <img
        src={`${API_URL}/${data[0]._photo}`}
        alt="Student"
        style={{
          marginTop: "-15px",
          width: "150px",
          height: "150px",
          float: "right",
          marginRight: "45px",
          objectFit: "cover",
          border: "none",
        }}
      />

      {data.map((item, index) => (
  <div key={index} style={{fontSize:"21px",}}>
    {Object.entries(item)
      .filter(([key]) => !key.startsWith("_")) // 🚫 skip keys starting with "_"
      .map(([key, value]) => (
        <p key={key}>
          {key}: <strong>{value}</strong>
        </p>
      ))}
  </div>
))}


      

    <div
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start", 
    marginLeft: "50%",         
    marginTop: "-150px"
  }}
>
  <div
    style={{
      width: "250px",
      height: "220px",
      border: "3px solid grey",
      padding: "10px",
      boxSizing: "border-box",
      fontWeight: "bold",
      backgroundColor: "#fff",
    }}
  >
    <p style={{ marginTop: "165px", fontSize: "1.2rem" }}>
      Signature: ___________
    </p>
  </div>

  <br />

  <div
    style={{
      textAlign: "center",
      fontWeight: "normal",
      whiteSpace: "nowrap",  
    }}
  >
    {data[0]?._description}
  </div>
</div>
  
    </div>
  );
};

export default PassCard;
